require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-4-ovrhb-cos-tzz-18-u-299-n-o-44.json") })
        }
      }, "path---news-c-4-ovrhb-cos-tzz-18-u-299-n-o-44");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-4-ovrhb-cos-tzz-18-u-299-n-o-44!./.cache/json/news-c-4-ovrhb-cos-tzz-18-u-299-n-o-44.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-4-ovrhb-cos-tzz-18-u-299-n-o-44!./.cache/json/news-c-4-ovrhb-cos-tzz-18-u-299-n-o-44.json
// module chunks = 231608221292675